// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/personalInfo/PersonalInfo.css
// module id = 978
// module chunks = 0